<div class="canvas-chat-container">
  <div class="canvas-chat-header">
    <div class="canvas-citation-title">Citations</div>

    <div class="canvas-chat-action-container">
      <img
        src="../../../../assets/icons/svg/close-square.svg"
        alt="Drawer"
        height="25"
        width="25"
        class="canvas-chat-action-button action-icon"
        (click)="canvasService.closeDrawer()"
        (keydown)="canvasService.closeDrawer()"
      />
    </div>
  </div>

  <div class="chats-list-container scrollbar-custom-scroll-style">
    <div
      class="saved-chat-item"
      *ngFor="let source of canvasService.sourcesList; let i = index"
      (click)="onSourceClicked(source)"
      (keydown)="onSourceClicked(source)"
    >
      <div
        class="d-flex flex-column align-items-start justify-content-even titles-container gap-2"
      >
        <ng-container *ngIf="source.dataset_id">
          <div class="d-flex gap-1 align-items-center justify-content-start">
            <img
              class="chat-action-icon cursor-pointer opacity-75"
              src="../../../../assets/icons/svg/fact_sheet.svg"
              alt="Close"
              height="19"
              width="15"
            />
            <span class="chat-time-title cursor-pointer"> Dataset </span>
          </div>
          <span class="chat-title cursor-pointer">
            {{ source.dataset_name }}</span
          >
        </ng-container>

        <ng-container *ngIf="source.url">
          <div class="d-flex gap-1 align-items-center justify-content-start">
            <img
              class="chat-action-icon cursor-pointer opacity-75"
              src="../../../../assets/icons/svg/chat-link.svg"
              alt="Close"
              height="19"
              width="15"
            />
            <span class="chat-time-title link cursor-pointer"> Website </span>
          </div>
          <span class="chat-title cursor-pointer">{{
            source.website_title
          }}</span>
        </ng-container>

        <ng-container *ngIf="source.document_id">
          <div class="d-flex gap-1 align-items-center justify-content-start">
            <img
              class="chat-action-icon cursor-pointer opacity-75"
              src="../../../../assets/icons/svg/chat-document.svg"
              alt="Close"
              height="19"
              width="15"
            />
            <span class="chat-time-title cursor-pointer"> Document </span>
          </div>
          <span class="chat-title cursor-pointer">{{
            source.document_title
          }}</span>
        </ng-container>

        <ng-container *ngIf="source.excel_dataset_id">
          <div class="d-flex gap-1 align-items-center justify-content-start">
            <img
              class="chat-action-icon cursor-pointer opacity-75"
              src="../../../../assets/icons/svg/chat-excel.svg"
              alt="Close"
              height="19"
              width="15"
            />
            <span class="chat-time-title cursor-pointer"> Excel Dataset </span>
          </div>
          <span class="chat-de cursor-pointer">
            {{ source.excel_dataset_name }}</span
          >
        </ng-container>
      </div>
    </div>
  </div>
</div>
